import http from '@/js/Http'
import {AxiosOptions} from 'guaxinim-web'

export default {
  create(entity) {
    const url = `/cidade/`
    return new Promise((resolve, reject) => {
      http.post(url, entity).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  edit(id, entity) {
    const url = `/cidade/${id}`
    return new Promise((resolve, reject) => {
      http.put(url, entity).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  findCidadeFinderDTO(ids, busca, limite) {
    const params = {
      ids,
      busca,
      limite
    }
    const options = {
      ...AxiosOptions,
      params
    }
    const url = `/cidade/finder`
    return new Promise((resolve, reject) => {
      http.get(url, options).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  findCidadeFinderDTOByID(id) {
    const url = `/cidade/finder/${id}`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  findDTOByID(id) {
    const url = `/cidade/dto/${id}`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  findDTOs(ids, filterparams) {
    const params = {
      ids,
      filterparams
    }
    const options = {
      ...AxiosOptions,
      params
    }
    const url = `/cidade/dto`
    return new Promise((resolve, reject) => {
      http.get(url, options).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  findEntities(ids) {
    const params = {
      ids
    }
    const options = {
      ...AxiosOptions,
      params
    }
    const url = `/cidade/`
    return new Promise((resolve, reject) => {
      http.get(url, options).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  findEntityByID(id) {
    const url = `/cidade/${id}`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  getDtoPresentation() {
    const url = `/cidade/dto/presentation`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  getPresentation() {
    const url = `/cidade/presentation`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  newEntity() {
    const url = `/cidade/new`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  remove(id) {
    const url = `/cidade/${id}`
    return new Promise((resolve, reject) => {
      http.delete(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  }
}